import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideIn16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowSlideIn16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.88 13.04a5 5 0 0 1-2.66-.925l.817-.895a3.847 3.847 0 1 0-.33-6.197l-.894-.815a5.03 5.03 0 0 1 3.328-1.254l.26.007a5.046 5.046 0 0 1 4.78 4.78l.007.259a5.047 5.047 0 0 1-5.047 5.047zm-3.95-2.897a.6.6 0 0 1-.849-.849l.683-.683H1.477a.6.6 0 0 1 0-1.199h4.296l-.692-.692a.6.6 0 1 1 .848-.848l2.135 2.136z"
            />
        </svg>
    );
}
export default memo(IconArrowSlideIn16);
